import { ar } from "./ar";
import { en } from "./en";

const messages = {
  ar,
  en,
};

export default messages;
